export default "__VITE_ASSET__CLcIbSwD__"